import api from "@/api/stream";

import router from "@/router";

import setts from "@/config/setts";

export const getLink = ({ commit }) => {
  api
    .getLink()
    .then(res => {
      commit("SET_LINKS_TO_STREAM", res.data);
    })
    .catch();
};

export const updateOnStopOfStream = ({ commit }, { id, duration }) => {
  api
    .updateOnStopOfStream(id, { duration })
    .then(response => {
      commit("FETCH_CURRENT_STREAM", response.data[0]);
      commit("UPDATE_STREAM", response.data);
      console.log(response);
    })
    .catch(error => {
      console.log(error.response);
    });
};

export const storeStream = ({ commit, dispatch }, playload) => {
  const formData = new FormData();
  for (const key in playload) {
    let res = playload[key];
    if (playload[key] !== null) {
      if (typeof playload[key] === "boolean") {
        res = playload[key] === true ? 1 : 0;
      }
      formData.append(key, res);
    }
  }

  api
    .storeStream(formData)
    .then(res => {
      console.log(res);
      
      commit("FETCH_CURRENT_STREAM", res.data);
      router.push({
        name: "ShowStream",
        params: { id: res.data.id },
        query: { new: true }
      });
    })
    .catch(error => {
      dispatch("hideSpinner", null, { root: true });
      const err = error.response.data;
      dispatch(
        "showNotification",
        {
          message: err.message,
          type: "error"
        },
        {
          root: true
        }
      );
    });
};

export const removeStream = ({ commit, dispatch }, id) => {
  dispatch("showSpinner", { title: "Remove stream" }, { root: true });

  commit("REMOVE_CURRENT_STREAM", id);

  api
    .removeStream(id)
    .then(() => {
      dispatch("hideSpinner", null, { root: true });
    })
    .catch(error => {
      dispatch("hideSpinner", null, { root: true });
      const err = error.response.data;
      dispatch(
        "showNotification",
        {
          message: err.message,
          type: "error"
        },
        {
          root: true
        }
      );
    });
};

export const updateStream = (
  { commit, dispatch },
  { playload, id, updated }
) => {
  dispatch("showSpinner", { title: "Update stream" }, { root: true });

  router.go(-1);
  commit("FETCH_CURRENT_STREAM", updated);

  api
    .updateStream(playload, id)
    .then(res => {
      dispatch("hideSpinner", null, { root: true });
      commit("UPDATE_STREAM", res.data);
    })
    .catch(error => {
      dispatch("hideSpinner", null, { root: true });
      const err = error.response.data;
      dispatch(
        "showNotification",
        {
          message: err.message,
          type: "error"
        },
        {
          root: true
        }
      );
    });
};

export const selectStream = ({ commit }, id) => {
  commit("LIST_CURRENT_STREAM", id);
};

export const fetchStream = ({ commit, dispatch }, id) => {
  dispatch("showSpinner", { title: "Fetch stream" }, { root: true });

  api
    .getStream(id)
    .then(res => {
      dispatch("hideSpinner", null, { root: true });

      commit("FETCH_CURRENT_STREAM", res.data);
    })
    .catch(error => {
      dispatch("hideSpinner", null, { root: true });

      const err = error.response.data;
      dispatch(
        "showNotification",
        {
          message: err.message,
          type: "error"
        },
        {
          root: true
        }
      );
    });
};

export const fetchSharedStream = ({ commit, dispatch }, key) => {
  dispatch("showSpinner", "Fetch shared stream", { root: true });

  api
    .getSharedStream(key)
    .then(res => {
      dispatch("hideSpinner", null, { root: true });
      commit("FETCH_CURRENT_STREAM", res.data);
    })
    .catch(error => {
      dispatch("hideSpinner", null, { root: true });

      const err = error.response.data;
      dispatch(
        "showNotification",
        {
          message: err.message,
          type: "error"
        },
        {
          root: true
        }
      );
    });
};

export const changeScope = ({ commit, state }, scope) => {
  if (state.streams.scope !== scope) {
    commit("CLEAR_ALL");
    commit("SET_SCOPE_STREAMS_LIST", scope);
  }
};

export const changeSearch = ({ commit, state }, search) => {
  if (state.streams.search !== search) {
    commit("CLEAR_STREAMS");
    commit("SET_SEARCH_STREAMS_LIST", search);
  }
};

export const changeFilter = ({ commit }, filter) => {
  commit("CLEAR_STREAMS");
  commit("SET_FILTER_STREAMS_LIST", filter);
};

export const clearStatus = ({ commit }) => {
  commit("CLEAR_STATUS");
};

export const fetchStreams = ({ commit, state, dispatch }) => {
  commit("STATUS_WAITING");

  if (state.streams.data.length === 0) {
    dispatch("showSpinner", { title: "Fetch streams" }, { root: true });
  }

  api
    .getStreams({
      page: state.streams.page,
      limit: setts.streamsList.limitOnPage,
      scope: state.streams.scope,
      filter: state.streams.filter,
      search: state.streams.search
    })
    .then(res => {
      commit("STATUS_SUCCESS");

      if (state.streams.data.length === 0) {
        dispatch("hideSpinner", null, { root: true });
      }

      commit("SET_STREAMS", res.data.data);
      // if (res.data.data.length > 0) {
      //   commit("PLUS_PAGE");
      // } else {
        commit("LIST_FINISHED");
      // }
    })
    .catch(error => {
      commit("STATUS_ERROR");
      dispatch("hideSpinner", null, { root: true });

      const err = error.response.data;
      dispatch(
        "showNotification",
        {
          message: err.message,
          type: "error"
        },
        {
          root: true
        }
      );
    });
};

export const clearStreams = ({ commit }) => {
  commit("CLEAR_STREAMS");
};

export const clearAll = ({ commit }) => {
  commit("CLEAR_ALL");
};

export const toggleLikeStream = ({ commit, dispatch }, id) => {
  api
    .toggleLikeStream(id)
    .then(res => {
      commit("UPDATE_STREAM", res.data[0]);
    })
    .catch(error => {
      const err = error.response.data;
      dispatch(
        "showNotification",
        {
          message: err.message,
          type: "error"
        },
        {
          root: true
        }
      );
    });
};
